import React from 'react';
import ReactDOM from 'react-dom/client';

import AnalysisUISkeleton from 'analysis-tool/ui/AnalysisUISkeleton';
import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import AnalysisTabState from './AnalysisTabState';

export default class AnalysisTabView extends BufferTabView<AnalysisTabState> {
  reactRoot: ReactDOM.Root | null = null;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    this.reactRoot = renderToDOM(
      <AnalysisUISkeleton
        analysisId={this.model.get('analysisId')}
        clientStateId={this.model.get('analysisId')}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): BufferTabView<AnalysisTabState> {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

AnalysisTabView.initClass();
